module.exports = __webpack_public_path__ + "img/13.a6902fb2.webp";